import React from 'react';

function ThumbnailName({ user, isSelf = true }) {
  const thumbnailUrl = user.thumbnail ? `/files/thumbnail/${user.thumbnail}` : '/noimage.png';

  const pointLabel = isSelf ? 'あなたの参加チケット' : `${user.name}さんの参加チケット`;
  const canCreateRooms = Number(user.owner_permission ?? 0) > 0;
  const ownerCreateLimit = Number(user.owner_create_limit ?? 0).toLocaleString();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px' }}>
        <img
            src={thumbnailUrl}
            alt="thumb"
            style={{ width: '80px', height: '80px', borderRadius: '50%' }}
        />
        <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{user.name}</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{pointLabel}：{user.ticket}枚</div>
          {canCreateRooms && (
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>ルーム作成可能数：{ownerCreateLimit}回</div>
          )}
        </div>
    </div>
  )
}

export default ThumbnailName;
